export default "__VITE_ASSET__BQruZFEV__"